/**
 * start listen value changes
 *
 * @example
 * subscribeValue(() => element.clientHeight, (height) => {
 *   console.log('new element height is', height)
 * })
 *
 * @returns unsubscribe fn
 */
function subscribeValue<T>(
  valueGetter: () => T,
  fn: (value?: T) => void,
): Function {
  let prevValue = valueGetter();
  let rafId;

  function update() {
    const newValue = valueGetter();

    if (prevValue !== newValue) {
      prevValue = newValue;
      fn(newValue);
    }

    if (rafId) {
      cancelAnimationFrame(rafId);
    }

    rafId = requestAnimationFrame(update);
  }

  update();

  return () => {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  };
}

export default subscribeValue;
